module.exports = __webpack_public_path__ + "img/winner-6th.57008821.png";